const en = {
    '/': '/',
    '/404/': '/404/',
    '/speaker/': '/speaker/',
    '/programma/': '/agenda/',
    '/workshop/': '/workshop/',
    '/evento/': '/event/',
    '/acquista/': '/buy/',
    '/contatti/': '/contact-us/',
    '/info/': '/info/',
    '/privacy/': '/privacy/',
    '/chi-siamo/': '/about-us/',
    '/grazie-dell-acquisto/': '/thank-you-for-the-purchase/',
    '/grazie-dell-acquisto-report/': '/thank-you-for-the-report-purchase/',
    '/fotogallery/': '/photogallery/',
    '/rassegna-stampa/': '/press-review/',
}

module.exports = {
    it: path => path,
    en: path => en[path]
}